var _effectorFileName = "/builds/gmini/front-ui-kit/src/InputProgress/InputProgress.tsx";
import React from 'react';
import styled from 'styled-components';
import { Box } from '../Box';
import { LinearProgress } from '../LinearProgress';
import { jsx as _jsx } from "react/jsx-runtime";
export const StyledLinearProgress = styled(LinearProgress)({
  borderTopLeftRadius: 4,
  borderTopRightRadius: 4
});
export const InputProgress = /*#__PURE__*/React.memo(({
  show
}) => /*#__PURE__*/_jsx(Box, {
  height: "4px",
  position: "absolute",
  top: 0,
  left: 0,
  zIndex: 100,
  width: "100%",
  children: show && /*#__PURE__*/_jsx(StyledLinearProgress, {})
}));
InputProgress.displayName = 'InputProgress';